import request from '@/lib/request/request'
const baseURL = `/dst-apis/1`
import { calPartHost } from '@/lib/utils'
import axios from 'axios'
// 字典
export function getSimpleDictByType(params) {
  return request({
    url: `/operateCore/dict/getSimpleDictByType`,
    method: 'get',
    baseURL,
    params
  })
}

// 获取大区 城市  运营公司
export function getOrgList(data) {
  return request({
    url: '/operateCore/openapi/orgvirtual/operation/getList',
    method: 'post',
    baseURL,
    data
  })
}

// 获取大区下的运营城市
export function getDownOrgMap(data) {
  return request({
    url: '/operateCore/openapi/orgvirtual/operation/getDownOrgMap',
    method: 'post',
    baseURL,
    data
  })
}

// 获取隐私号权限
export function mobilePrivacyProtectPermission(data) {
  return request({
    url: '/voc-apis/mobile/privacy-protect/permission',
    method: 'post',
    baseURL,
    data
  })
}

// 隐私号通话虚拟号获取
export function mobilePrivacyProtectAxb(data) {
  return request({
    url: '/voc-apis/mobile/privacy-protect/axb',
    method: 'post',
    baseURL,
    data
  })
}

// 获取品牌型号
export function findAttrValueInheritListByAttrKey(params) {
  return request({
    url: '/marketing/attributeValue/findAttrValueInheritListByAttrKey',
    method: 'get',
    baseURL,
    params
  })
}

// 获取属性组
export function selectable(data) {
  return request({
    url: '/marketing/attributeManage/manufacture/process/selectable',
    method: 'post',
    baseURL,
    data
  })
}
// 查询物料属性配置接口
export function getAttrConfigKeys(data) {
  return request({
    url: '/vehicleCenter/openapi/material/attrConfigKey',
    method: 'post',
    baseURL,
    data
  })
}

// 需维修定损项
export function getSmartFeeGoods(data) {
  return request({
    url: '/api-maintain-platform/assistant/reservation/smart/getSmartFeeGoods',
    method: 'post',
    baseURL,
    data
  })
}

// 获取单状态字典数据（字典-PHP）
export function getStatusList(data) {
  return request({
    baseURL,
    url: `/api-maintain-platform/operate/base/dictionaries/lists`,
    method: 'post',
    data
  })
}

// 车辆调拨提交接口
export function updateOperaCarDispensing(data) {
  return request({
    baseURL,
    url: `vehicleCenter/openapi/vehicle/updateOutOperaCarDispensing`,
    method: 'post',
    data
  })
}

export function recordPrivacyLog(data) {
  return request({
    baseURL: '/dst-apis',
    url: '/dst-security-core-service/v1/sensitive/viewlog/add',
    method: 'post',
    data
  })
}

export function privilegeInfoByClientId(params) {
  return request({
    baseURL: '/dst-apis',
    url: '/user-org/auth/portal/menu/privilegeInfoByClientId',
    method: 'get',
    params
  })
}

// 思倍云/车上云切换接口
export function decision(version) {
  return request({
    baseURL,
    url: `/operateCore/version/ltzs/decision/${version}`,
    method: 'get'
  })
}

// 替换token
export function checkAccessToken(token) {
  return axios.post(
    `https://portal-gw-space${calPartHost()}/portal/v1/api/checkAccessToken`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  )
}

// 获取projectCode
export function queryResourceByExternalCode(token, data) {
  return axios.post(
    `https://portal-gw-space${calPartHost()}/space/v1/api/open/queryResourceByExternalCode`,
    data,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  )
}

// 获取属性list
export function getListByParam(data) {
  return request({
    url: '/vehicleCenter/vehicleAttrCategoryConfig/getListByParam',
    method: 'post',
    data,
    baseURL: '/dst-apis/1'
  })
}

// 查询启用的属性展示配置规则列表
export function getAttributeDisplayRules(data) {
  return request({
    url: 'vehicleCenter/attributeDisplayConfig/getRules',
    method: 'get',
    params: data,
    baseURL: '/dst-apis/1'
  })
}



// WEBPACK FOOTER //
// ./src/api/base.js